import { API_URL } from '../config';
import { Subfamily } from '../types';

export const subfamilyService = {
  // Obtener todas las subfamilias
  async getSubfamilies(familyId?: string): Promise<Subfamily[]> {
    const url = familyId 
      ? `${API_URL}/subfamilies?family_id=${familyId}` 
      : `${API_URL}/subfamilies`;
    
    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Error al obtener subfamilias');
    }

    const data = await response.json();
    // Handle the new response structure with pagination
    return data.subfamilies || data;
  },

  // Obtener subfamilia por ID
  async getSubfamilyById(id: string): Promise<Subfamily> {
    const response = await fetch(`${API_URL}/subfamilies/${id}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Error al obtener subfamilia');
    }

    return response.json();
  },

  // Crear nueva subfamilia
  async createSubfamily(subfamilyData: Omit<Subfamily, 'id'>): Promise<Subfamily> {
    const response = await fetch(`${API_URL}/subfamilies`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(subfamilyData)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al crear subfamilia');
    }

    return response.json();
  },

  // Actualizar subfamilia
  async updateSubfamily(id: string, subfamilyData: Partial<Subfamily>): Promise<Subfamily> {
    const response = await fetch(`${API_URL}/subfamilies/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(subfamilyData)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al actualizar subfamilia');
    }

    return response.json();
  },

  // Eliminar subfamilia
  async deleteSubfamily(id: string): Promise<void> {
    const response = await fetch(`${API_URL}/subfamilies/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al eliminar subfamilia');
    }
  },

  // Obtener subfamilias con paginación
  async getSubfamiliesWithPagination(
    page: number = 1, 
    limit: number = 10, 
    familyId?: string, 
    searchTerm?: string
  ): Promise<{
    subfamilies: Subfamily[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalItems: number;
      itemsPerPage: number;
    };
  }> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });

    if (familyId) {
      params.append('family_id', familyId);
    }

    if (searchTerm) {
      params.append('search', searchTerm);
    }

    const response = await fetch(`${API_URL}/subfamilies?${params}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Error al obtener subfamilias');
    }

    return response.json();
  }
};